import React from 'react'
import HeaderMain from '../../../Compoents/HeaderMain';
import BreadcrumbArea from '../../../ShearOne/BreadcrumbArea';
import FooterWhite from '../../../Compoents/FooterWhite';
import { Link } from 'react-router-dom';


export const PostMarket = () => {
    const breadcrumbLinks = [
        { path: '/', label: 'Home' },
        { label: 'Post Market', active: true }
      ];
      return (
        <>
        <HeaderMain/>
        <main>
       
       <BreadcrumbArea 
         title="Post Market" 
         backgroundImage="/assets/imgs/breadcrumb/page-header-1.png" 
         links={breadcrumbLinks} 
       />
          <section class="service-details section-space">
  <div class="container">
    <div class="row flex-xl-row flex-column-reverse">
      <div class="col-xl-4">
        <div class="sidebar sidebar-rr-sticky">
          <div class="sidebar__widget-service mb-30">
            <Link to="/service">Medical Device Manufacturers <i class="fa-solid fa-plus"></i> </Link>
            <Link to="/pharmaceutical-details">Pharmaceutical & Biotech industry<i class="fa-solid fa-plus"></i> </Link>
            <Link to="/healthcare-details">Healthcare Providers <i class="fa-solid fa-plus"></i> </Link>
          </div>

          <div class="sidebar__widget-contact__service text-center">
            <h4 class="mb-25 title-animation text-capitalize">Are You ready to contact with us</h4>
            <p class="mb-20"><a href="tel:+86 19811976744"><i class="fa-solid fa-phone"></i>(+86) 19811976744</a></p>

            <Link to="/contact-us#" class="rr-btn">
              <span class="btn-wrap">
                <span class="text-one">Contact Us <i class="fa-solid fa-plus"></i></span>
                <span class="text-two">Contact Us <i class="fa-solid fa-plus"></i></span>
              </span>
            </Link>
          </div>
        </div>
      </div>

      <div class="col-xl-8">
        <div class="service-details__content">
          <div class="service-details__content-media mb-20">
            <img src="./assets/imgs/service-details/service-details-1.jpg" class="img-fluid" alt="Post Market Activities" />
          </div>

          <h2 class="title-animation mb-20">Post Market Activities</h2>

          <p class="mb-20">Post-market activities involve monitoring a medical device’s safety and effectiveness after it has been released to the market. This includes gathering user feedback, tracking adverse events, conducting post-market surveillance studies, and managing recalls or field safety corrective actions if needed. It also involves updating documentation and regulatory submissions with new information. These actions help ensure the device remains high-quality, compliant with regulations, and safe for patients.</p>

          <h3 class="title-animation mb-10">Types of Post Market Activities for the Medical Device Industry</h3>
          <ul class="mb-30">
            <li><span><i class="fa-solid fa-check"></i></span>Post-Market Surveillance (PMS)</li>
            <li><span><i class="fa-solid fa-check"></i></span>Post-Market Clinical Follow-up</li>
            <li><span><i class="fa-solid fa-check"></i></span>Post-Market Performance Follow-up</li>
          </ul>

          <h3 class="title-animation mb-10">SQUARE MEDTECH Expertise in Post Market Activities</h3>
          <p class="mb-30">To simplify your regulatory tasks and conserve internal resources, SQUARE MEDTECH provides ongoing services to keep your technical documentation up to date and to monitor your device's safety and performance post-market.</p>

          <h3 class="title-animation mb-10">How SQUARE MEDTECH Can Help in PMS Activities</h3>
          <ul class="mb-40">
            <li><span><i class="fa-solid fa-check"></i></span>Adverse Event Monitoring</li>
            <li><span><i class="fa-solid fa-check"></i></span>Post-Market Surveillance</li>
            <li><span><i class="fa-solid fa-check"></i></span>Post-Market Clinical Follow-up</li>
            <li><span><i class="fa-solid fa-check"></i></span>Post-Market Performance Follow-up</li>
            <li><span><i class="fa-solid fa-check"></i></span>Regulatory Compliance</li>
            <li><span><i class="fa-solid fa-check"></i></span>Recall Management</li>
            <li><span><i class="fa-solid fa-check"></i></span>Data Analysis and Reporting</li>
          </ul>

          <div class="row">
            <div class="col-lg-7">
              <div class="service-details__content-media-item service-details__content-media-item-1">
                <div class="service-details__content-media-item_img mb-10">
                  <img src="./assets/imgs/service-details/service-details-2.jpg" class="img-fluid" alt="PMS Activities" />
                </div>
                <h4 class="title-animation mb-15">Ensuring Post-Market Compliance</h4>
                <p>SQUARE MEDTECH provides comprehensive support to ensure that your post-market activities align with regulatory requirements, enabling you to maintain the highest safety and performance standards for your medical devices.</p>
              </div>
            </div>

            <div class="col-lg-5">
              <div class="service-details__content-media-item service-details__content-media-item-2">
                <div class="service-details__content-media-item_img mb-10">
                  <img src="./assets/imgs/service-details/service-details-3.jpg" class="img-fluid" alt="Post Market Support" />
                </div>
                <h4 class="title-animation mb-15">Our Expertise in Post-Market Activities</h4>
                <p>At SQUARE MEDTECH, our dedicated post-market support team combines industry knowledge and regulatory expertise to assist clients in ensuring their devices perform safely and effectively in the market.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

       
    </main>


    <section class="footer__cta footer__cta-bottom-up">
    <div class="container">
        <div class="row mb-minus-30">
            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-primary d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-1.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                    <h4 class="color-white mb-15 mb-10">Our PMS Services:</h4>
                    <ul class="color-white mb-0">
                      <li>Adverse Event Monitoring</li>
                      <li>PMS Technical Documentation</li>
                      <li>PMS Surveillance & Clinical Follow-up</li>
                    </ul>

                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-glow d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-2.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                        <h4 class="color-white mb-15 mb-10">Our PMS Services:</h4>
                        <ul class="color-white mb-0">
                          <li>Recall Management</li>
                          <li>Data Analysis & Reporting</li>
                          <li>Clinical Evaluation & Investigation</li>
                        </ul>

                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
    <FooterWhite/>

    </>
  )
}
